export default __webpack_public_path__ + "static/media/preview.1918e2d2.png";